module.exports = __webpack_public_path__ + "img/digitalstaging_ai_logo.672d1ff9.png";